export default "__VITE_ASSET__7xVmsQoo__"